<!------------------------------

      Page Actions

------------------------------->

<div *sbPageAction>
  <a (click)="openCreateModal()" *ngPermissions="permissionService.Permission.visitor_tracker_create">
    <sb-button classes="btn-success mr-0">
      <sb-icon icon="plus"></sb-icon>&nbsp;<span class="d-none d-sm-inline-block">
            {{'nav.network.tracker.createTracker' | translate}}</span>
    </sb-button>
  </a>
</div>

<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper (filterChange)="requestDebounced()" (optionsChange)="requestDebounced($event)"
                  [itemName]="'tracker'" [itemsData]="visitorTracker" [loading]="loading"
                  [options]="options" [showExactMatch]="true" headline="{{'nav.network.tracker' | translate}}">

  <!------------------------------

      Header More

  ------------------------------->

  <div header-more>
    <div class="d-flex align-items-center">
      <sb-multi-dropdown (dataChange)="toggleChange($event)" [data]="initialToggles"
                         headline="{{'lang.globals.filterAttributes' | translate}}">

      </sb-multi-dropdown>
      <sb-comp-dropdown-select
        (msOptionsChange)="msRequest('LOCATIONS', $event)" (selectedDataEmitter)="update($event, 'LOCATIONS')"
        [dropDownDatatype]="'LOCATIONS'" [inputData]="locations"
        [msOptions]="msLocationOptions" [selectedInputData]="filteredLocations"
        [showColumnIcon]="false">
      </sb-comp-dropdown-select>
    </div>
  </div>


  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>

    <tr>
      <th>
        {{'lang.globals.status' | translate}}
      </th>
      <th>
        {{'lang.globals.id' | translate}}
      </th>
      <th>
        {{'lang.globals.technique' | translate}}
      </th>
      <th>
        {{'lang.globals.identifier' | translate}}
      </th>
      <th>
        {{'lang.globals.name' | translate}}
      </th>
      <th>
        {{'lang.globals.disabled' | translate}}
      </th>
      <th>
        {{'lang.globals.productive' | translate}}
      </th>
      <th>
        {{'lang.globals.external' | translate}}
      </th>
      <th>
        {{'lang.globals.timezone' | translate}}
      </th>
      <th>
        {{'lang.globals.location' | translate}}
      </th>
      <th class="tr">
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-tracker>

    <tr>
      <td>
        <sb-icon *ngIf="!tracker?.offline" class="green" icon="online">Online</sb-icon>
        <sb-icon *ngIf="tracker?.offline" class="red" icon="offline">Offline</sb-icon>
      </td>
      <td>
        {{tracker?.id}}
      </td>
      <td>
        <sb-icon [ngbTooltip]="tracker.technique" container="body" icon="{{util.getTrackerIcon(tracker)}}"></sb-icon>
      </td>
      <td>
        <span [innerHTML]="tracker?.identifier | truncate: 50">
        </span>
      </td>
      <td>
        <sb-comp-link
          [link]="util.RoutingID.trackerDetails"
          [pathParams]="[{id: 'trackerID',value: tracker?.id}]"
          [permission]="permissionService.Permission.visitor_tracker_show"
          [title]="tracker?.name"
          [tooltip]="'lang.globals.details' | translate">
        </sb-comp-link>
      </td>
      <td>
        <sb-icon *ngIf="tracker?.disabled" class="green" icon="success"></sb-icon>
        <sb-icon *ngIf="!tracker?.disabled" class="red" icon="error"></sb-icon>
      </td>
      <td>
        <sb-icon *ngIf="tracker?.productive" class="green" icon="success"></sb-icon>
        <sb-icon *ngIf="!tracker?.productive" class="red" icon="error"></sb-icon>
      </td>
      <td>
        <sb-icon *ngIf="tracker?.external" class="green" icon="success"></sb-icon>
        <sb-icon *ngIf="!tracker?.external" class="red" icon="error"></sb-icon>
      </td>
      <td>
        {{tracker?.timezone}}
      </td>
      <td>
        <a *ngIf="tracker?.location && permissionService.hasPermission(permissionService.Permission.visitor_tracker_show)"
           [pathParams]="[{id: 'locationID',value: tracker?.location?.id}]"
           [sbRouterLink]="util.RoutingID.locationDetails">
          {{tracker?.location?.name}}
        </a>
        <span *ngIf="!permissionService.hasPermission(permissionService.Permission.location_show)">
        {{tracker?.location?.name}}
        </span>
      </td>
      <td class="tr sticky-col last-col tableBg">
        <sb-table-buttons>
          <a *ngPermissions="permissionService.Permission.visitor_tracker_show"
             [pathParams]="[{id: 'trackerID',value: tracker?.id}]"
             [sbRouterLink]="util.RoutingID.trackerDetails"
             class="btn btn-primary" container="body"
             ngbTooltip="{{'lang.globals.details' | translate}}">
            <sb-icon icon="details"></sb-icon>
          </a>
          <a (click)="editTracker(tracker)"
             *ngPermissions="permissionService.Permission.visitor_tracker_edit" class="btn btn-secondary"
             container="body" ngbTooltip="{{'nav.network.tracker.editTracker' | translate}}">
            <sb-icon icon="edit"></sb-icon>
          </a>
          <a (click)="deleteTracker(tracker)"
             *ngPermissions="permissionService.Permission.visitor_tracker_delete"
             class="btn btn-danger" container="body"
             ngbTooltip="{{'lang.globals.delete' | translate}}">
            <sb-icon icon="trash"></sb-icon>
          </a>
        </sb-table-buttons>
      </td>
    </tr>
  </ng-template>

  <!------------------------------

   Card Element

------------------------------->

  <ng-template #card let-tracker>
    <sb-card>
      <div card-header>
        {{tracker.identifier}}
      </div>
      <div card-header-more>
        <sb-table-buttons>
          <a *ngPermissions="permissionService.Permission.visitor_tracker_show"
             [pathParams]="[{id: 'trackerID',value: tracker?.id}]"
             [sbRouterLink]="util.RoutingID.trackerDetails"
             class="btn btn-primary" container="body"
             ngbTooltip="{{'lang.globals.details' | translate}}">
            <sb-icon icon="details"></sb-icon>
          </a>
          <a (click)="editTracker(tracker)"
             *ngPermissions="permissionService.Permission.visitor_tracker_edit" class="btn btn-secondary"
             container="body" ngbTooltip="{{'nav.network.tracker.editTracker' | translate}}">
            <sb-icon icon="edit"></sb-icon>
          </a>
          <a (click)="deleteTracker(tracker)"
             *ngPermissions="permissionService.Permission.visitor_tracker_delete"
             class="btn btn-danger" container="body"
             ngbTooltip="{{'lang.globals.delete' | translate}}">
            <sb-icon icon="trash"></sb-icon>
          </a>
        </sb-table-buttons>
      </div>
      <div card-body>
        <sb-value-definition [text]="tracker?.timezone"></sb-value-definition>
      </div>
    </sb-card>
  </ng-template>

</sb-table-wrapper>
